import { defineStore } from 'pinia';
import axios from 'axios';

export const usePresentationStore = defineStore('presentation', {
  state: () => ({
    presentations: [],
    apiBaseUrl: 'https://tegiot.inl.int/api',
    autoplay: 0
  }),
  actions: {
    async fetchPresentations(code) {
      try {
        const response = await axios.get(`${this.apiBaseUrl}/v2/presentations?code=${code}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
         this.presentations = response.data.projects.sort((a, b) => {
            return (b.in_code === true) - (a.in_code === true);
          });
      } catch (error) {
        if (error.response && error.response.data) {
          throw new Error(error.response.data);
        } else {
          throw new Error("An unknown error occurred while fetching presentations.");
        }
      }
    },
    async fetchPresentation(code,presentation) {
      try {
        const response = await axios.get(`${this.apiBaseUrl}/presentation?code=${code}&presentation=${presentation}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        return response.data.presentation;
      } catch (error) {
        if (error.response && error.response.data) {
          throw new Error(error.response.data);
        } else {
          throw new Error("An unknown error occurred while fetching presentations.");
        }
      }
    },
    async fetchPresentationsWithMedias(code) {
      try {
        const response = await axios.get(`${this.apiBaseUrl}/presentations/${code}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        return response.data.projects;
      } catch (error) {
        if (error.response && error.response.data) {
          throw new Error(error.response.data);
        } else {
          throw new Error("An unknown error occurred while fetching presentations.");
        }
      }
    },
  },
  getters: {
    getPresentations: (state) => state.presentations,
    getApiBaseUrl: (state) => state.apiBaseUrl,
    getAutoplay: (state) => state.autoplay,
  },
});
